import { render, staticRenderFns } from "./SimpleLinks.vue?vue&type=template&id=8fd56c68&"
import script from "./SimpleLinks.vue?vue&type=script&lang=js&"
export * from "./SimpleLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports